import { useCallback, useEffect, useState } from 'react';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import { CarouselArrow, ProductCategory } from '../../shared/components/';

import style from './Menu.module.css';

import { getCategories } from '../../shared/services/categories';

export const Menu = () => {

  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    (async () => {
      setCategories(await getCategories());
    })()
  }, [])

  const drawProductsSlides = useCallback(() => {
    let productSlidesList: React.ReactElement[] = [];
    categories.map((category, key) => productSlidesList.push(
      <ProductCategory name={category.name} categoryId={category.id} key={key} />
    ));
    return productSlidesList;
  }, [categories])

  const scrollToUp = () => {
    document.documentElement.scrollTop > 160 &&
      document.documentElement.scrollTo(0, 160)
  }

  const createCarouselArrow = (direction?: 'left' | 'right') => {
    return (clickHandler: () => void, hasNext: boolean) => {
      return (hasNext && <CarouselArrow onClick={clickHandler} direction={direction} />)
    }
  }

  return (
    <div className={style.Menu}>
      <Carousel
        preventMovementUntilSwipeScrollTolerance
        swipeScrollTolerance={70}
        emulateTouch
        autoPlay={false}
        children={drawProductsSlides()}
        showIndicators={false}
        showStatus={false}
        showThumbs={false}
        renderArrowNext={createCarouselArrow('right')}
        renderArrowPrev={createCarouselArrow('left')}
        className={style.Carousel}
        onChange={() => scrollToUp()}
      />
    </div>
  );
}
